import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class CheckboxField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || false
    this.props.setFormFieldValue(formType, fieldName, initialValue)
    this.props.validateFormField(formType, fieldName, initialValue)
  }

  valueChange(e) {
    const { formType, fieldName, onChange } = this.props
    this.props.setFormFieldValue(formType, fieldName, e.target.checked)
    this.props.validateFormField(formType, fieldName, e.target.checked)
    if (typeof onChange !== 'undefined') {
      onChange(e)
    }
  }

  render() {
    const { form, formType, fieldName, label, additionalClass, defaultValue, isDisabled } =
      this.props
    return (
      <div className={`field field-checkbox ${additionalClass || ''}`}>
        <div className="control">
          <input
            type="checkbox"
            name={fieldName}
            onChange={this.valueChange}
            id={fieldName}
            checked={
              typeof form[formType][fieldName] !== 'undefined'
                ? form[formType][fieldName].value
                : defaultValue || false
            }
            disabled={isDisabled}
          />
          <label htmlFor={fieldName}>
            {fieldName === 'terms' && (
              <span>
                I agree with{' '}
                <a target="_blank" rel="noreferrer" href="/resources/LiabilityWaiver.pdf">
                  Liability Waiver
                </a>
              </span>
            )}
            {fieldName !== 'terms' && label}
          </label>
        </div>
      </div>
    )
  }
}

CheckboxField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.bool,
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  isDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(CheckboxField)
